<page-header [step]="step" [size]="size" *ngIf="projectType != 'event'"></page-header>

<event-header *ngIf="projectType === 'event' && step != 'thankyou' && step != 'end' && step != 'banktransfer' && step != 'contact'" [size]="size" [donationFormHidden]="hideDonationWidget" ></event-header>

<div class="widget-header {{ version }} {{ step }}" [class.widget]="version === 'widget' || forceWidgetTeaser" [class.no-headline]="showWidgetHeadline == false" *ngIf="(version == 'widget' || (forceWidgetTeaser && version != 'page')) && step == 'start' && projectType != 'event'">
	<!-- Headline -->
	<headline [step]="step" *ngIf="version != 'page' && !showPageheaderRedirectText" (toggleHeadline)="toggleWidgetHeadline($event)"></headline>

	<div *ngIf="showPageheaderRedirectText" class="widget-teaser-redirect">
		<div class="row column" [innerHTML]="'pageheader.thankyou' | translate"></div>
	</div>

	<!-- Progess bar -->
	<project-progress *ngIf="step != 'end'" [size]="size"></project-progress>

	<div class="row widget-teaser" *ngIf="forceWidgetTeaser">
		<div class="column">
			<h2 class="show-for-small-only" [innerHTML]="'pageheader.subheadline' | translate"></h2>
			<p class="teaser show-for-medium" [innerHTML]="'pageheader.teaser' | translate | nl2br"></p>
		</div>
	</div>
</div>

<!-- Output for form -->
<div class="form {{ step }}" *ngIf="version == 'form' && !hideDonationWidget">

	<step-navigation [(step)]="step" (stepChange)="stepChange($event)" [donation]="donation" [(donationStatus)]="donationStatus" [size]="size" [projectType]="projectType"></step-navigation>

	<fullscreentext [step]="step"></fullscreentext>

	<!-- Progess bar -->
	<project-progress *ngIf="!forceWidgetTeaser && step != 'end' && projectType != 'event'" [size]="size"></project-progress>

	<!-- bonus, details -->
	<app-bonus *ngIf="step === 'bonus-details'" [donation]="donation" [form]="pageForm" [amount]="donation.amount" [rhythm]="donation.recurringRythm" [step]="step" (stepChange)="stepChange($event, true)"></app-bonus>

	<!-- donation -->
	<form onsubmit="document.getElementById('value').value.length > 0? this.submit() : false" [action]="getFormAction()" [class.event]="projectType == 'event'" [target]="paymentFormTarget" method="POST" (ngSubmit)="submitForm()" [formGroup]="pageForm" *ngIf="step == 'start'" novalidate>

		<!-- amount image -->
		<amount-image [donation]="donation"></amount-image>

		<!-- input / slider -->
		<amount [donation]="donation" [form]="pageForm"></amount>
		<amount-extra [donation]="donation" [form]="pageForm" [amount]="donation.amount"></amount-extra>

		<!-- rythm / target -->
		<rythm-target [donation]="donation" [form]="pageForm" [size]="size"></rythm-target>

		<!-- bonus -->
		<app-bonus [donation]="donation" [form]="pageForm" [step]="step" (stepChange)="stepChange($event, true)" [amount]="donation.amount" [rhythm]="donation.recurringRythm"></app-bonus>

		<!-- status -->
		<donation-status [(status)]="donationStatus" [message]="donationStatusMessage" [donation]="donation" (statusChange)="onStatusChange($event)"></donation-status>

		<!-- extra field -->
		<extrafield [contact]="contact" [form]="pageForm"></extrafield>

		<!-- contact -->
		<contact [donation]="donation" [contact]="contact" [form]="pageForm" [size]="size" [version]="version" [(step)]="step" (stepChange)="stepChange($event, true)" *ngIf="contactMandatory == true" [country]="donation.userCountry"></contact>

		<!-- payment -->
		<payment [donation]="donation" [contact]="contact" [amount]="donation.amount" [rythm]="donation.rythm" [form]="pageForm" [(donationStatus)]="donationStatus" [(step)]="step" (stepChange)="stepChange($event)" [size]="size" [version]="version"></payment>

		<!-- event Donator -->
		<donator [donation]="donation" [form]="pageForm" *ngIf="projectType === 'event' || showDonatorData"></donator>

		<!-- gift donation -->
		<gift-donationdata [donation]="donation" [form]="pageForm"></gift-donationdata>

		<!-- donation data for sending the data to an external form -->
		<hidden-formsubmit [id]="'value'" [donation]="donation" [contact]="contact" [step]="step" [size]="size" [form]="pageForm" [type]="version"></hidden-formsubmit>

		<!-- remarks on this donation -->
		<input-remarks [form]="pageForm" [donation]="donation" [wrapperClass]="'remarks-wrapper row column'"></input-remarks>

		<!-- Button -->
		<div class="row columns">
			<div id="expresscheckout"></div>
			<submit ariaLive="polite" [text]="paymentSubmitTextkey | translate: getSubmitButtonPlaceholders()" [arrow]="false" [additionalClasses]="pageForm.valid? '' : 'grey'" [secureText]="'payment.submit.hint' | translate"></submit>
		</div>

	</form>

	<!-- iframe -->
	<payment-iframe [donation]="donation" [buttonPlaceholders]="getSubmitButtonPlaceholders()" [projectType]="projectType" *ngIf="step == 'iframe'"></payment-iframe>

	<!-- step: thank you -->
	<thankyou-order [step]="step" [projectType]="projectType" [donation]="donation" [contact]="contact" [form]="contactForm" [size]="size" [version]="version" (stepChange)="stepChange($event, true)"></thankyou-order>
	
	<!-- share -->
	<share *ngIf="projectType == 'event'" [step]="step" [projectType]="projectType"></share>

	<!-- back button for events -->
	<div class="row column" *ngIf="projectType == 'event' && (step == 'thankyou' || step == 'end')">
		<button class="button arrow-left event-back" (click)="reloadWidget()" >{{'event.back.button' | translate }}</button>
	</div>

</div>

<!-- Output for widget, page -->
<div class="widget {{ step }}" *ngIf="(version == 'widget' || version == 'page') && !hideDonationWidget">

	<step-navigation *ngIf="!hasStepIndex" [(step)]="step" (stepChange)="stepChange($event)" [donation]="donation" [(donationStatus)]="donationStatus" [size]="size" [projectType]="projectType"></step-navigation>

	<!-- bonus, details -->
	<app-bonus *ngIf="step === 'bonus-details'" [donation]="donation" [form]="widgetStartForm" [amount]="donation.amount" [rhythm]="donation.recurringRythm" [step]="step" (stepChange)="stepChange($event, true)"></app-bonus>

	<step-index *ngIf="hasStepIndex" [steps]="getStepsForIndex()" [(step)]="step" [donation]="donation" [donationAmountStartStep]="'payment'" (stepChange)="stepChange($event)"></step-index>

	<fullscreentext [step]="step"></fullscreentext>

	<!-- amount, rythm and target -->
	<form onsubmit="document.getElementById('value1') && document.getElementById('value1').value.length > 0? this.submit() : false" [class.event]="projectType == 'event'" [action]="getFormAction()" [target]="paymentFormTarget" method="POST" (submit)="submitForm()" [formGroup]="widgetStartForm" *ngIf="step == 'start'" novalidate>

		<!-- amount image -->
		<amount-image [donation]="donation"></amount-image>

		<!-- input / slider -->
		<amount [donation]="donation" [form]="widgetStartForm"></amount>
		<amount-extra [donation]="donation" [form]="widgetStartForm" [amount]="donation.amount"></amount-extra>

		<!-- rythm / target -->
		<rythm-target [donation]="donation" [form]="widgetStartForm" [size]="size"></rythm-target>

		<!-- bonus -->
		<app-bonus [donation]="donation" [form]="widgetStartForm" [amount]="donation.amount" [rhythm]="donation.recurringRythm" [step]="step" (stepChange)="stepChange($event, true)"></app-bonus>

		<!-- Status -->
		<donation-status [status]="donationStatus" [donation]="donation" [message]="donationStatusMessage" (statusChange)="onStatusChange($event)" *ngIf="size == 'medium' || size == 'large'"></donation-status>

		<!-- extra field -->
		<extrafield [contact]="contact" [form]="widgetStartForm" *ngIf="version == 'page' && size != 'small' && contactMandatory == false"></extrafield>

		<!-- payment -->
		<payment [donation]="donation" [rythm]="donation.rythm" [amount]="donation.amount" [contact]="contact" [form]="widgetStartForm" [(donationStatus)]="donationStatus" [(step)]="step" (stepChange)="stepChange($event)" [size]=size  [version]="version" *ngIf="version == 'page' && (size == 'medium' || size == 'large') && !contactMandatory"></payment>

		<!-- event Donator -->
		<donator [donation]="donation" [form]="widgetStartForm" *ngIf="(projectType === 'event' || showDonatorData) && version == 'page' && (size == 'medium' || size == 'large')"></donator>

		<!-- gift donation -->
		<gift-donationdata [donation]="donation" [form]="widgetStartForm" *ngIf="step == 'start'"></gift-donationdata>

		<!-- donation data for sending the data to an external form -->
		<hidden-formsubmit [id]="'value1'" [donation]="donation" [contact]="contact" [type]="version" [step]="step" [size]="size" [form]="widgetStartForm"></hidden-formsubmit>

		<!-- remarks on this donation -->
		<input-remarks *ngIf="!(size== 'small' || version == 'widget')" [form]="widgetStartForm" [donation]="donation" [wrapperClass]="'remarks-wrapper row column'"></input-remarks>

		<!-- Button -->
		<div class="row columns">
			<div id="expresscheckout"></div>
			<submit ariaLive="polite" [text]="size== 'small' || version == 'widget' || contactMandatory == true ? ('widget.start.button' | translate: getSubmitButtonPlaceholders()) : (paymentSubmitTextkey | translate: getSubmitButtonPlaceholders())" [arrow]="size == 'small' || version == 'widget' || contactMandatory == true" [additionalClasses]="widgetStartForm.valid? ' ' : 'grey'" [secureText]="size != 'small' && version != 'widget' && contactMandatory == false ? ('payment.submit.hint' | translate) : ''"></submit>
		</div>
	</form>


	<!-- contact (if contact is mandatory) -->
	<form onsubmit="document.getElementById('value3').value.length > 0? this.submit() : false" [class.event]="projectType == 'event'" [action]="getFormAction()" [target]="paymentFormTarget" method="POST" (ngSubmit)="submitForm()" [formGroup]="contactForm" *ngIf="step == 'contact-mandatory' && contactMandatory == true" novalidate>
		<!-- Status -->
		<donation-status [status]="donationStatus" [message]="donationStatusMessage" [donation]="donation" (statusChange)="onStatusChange($event)"></donation-status>

		<!-- extra field -->
		<extrafield [contact]="contact" [form]="contactForm"></extrafield>

		<!-- contact data -->
		<contact [donation]="donation" [contact]="contact" [form]="contactForm" [size]="size" [version]="version" [(step)]="step" (stepChange)="stepChange($event, true)"  [country]="donation.userCountry"></contact>

		<!-- donation data for sending the data to an external form -->
		<hidden-formsubmit [id]="'value3'" [donation]="donation" [contact]="contact" [type]="version" [step]="step" [size]="size" [form]="contactForm"></hidden-formsubmit>

		<!-- Button -->
		<div class="row columns">
			<submit [text]="(size== 'small' || version == 'widget'? 'widget.start.button' : paymentSubmitTextkey) | translate: getSubmitButtonPlaceholders()" [additionalClasses]="contactForm.valid? '' : 'grey'"  [secureText]="step != 'contact' && version == 'page' && size != 'small' && !contactMandatory? ('payment.submit.hint' | translate) : ''" [arrow]="step != 'contact' && (version == 'widget' || size == 'small' || contactMandatory)"></submit>
		</div>
	</form>

	<!-- payment (small and widget only) -->
	<form onsubmit="document.getElementById('value2').value.length > 0? this.submit() : false" [action]="getFormAction()" [class.event]="projectType == 'event'" [target]="paymentFormTarget" method="POST" (ngSubmit)="submitForm()" [formGroup]="widgetPaymentForm" *ngIf="(step == 'payment' || step == 'payment-select') && (size == 'small' || version == 'widget' || contactMandatory)" novalidate>
		<!-- Status -->
		<donation-status [status]="donationStatus" [message]="donationStatusMessage" [donation]="donation" (statusChange)="onStatusChange($event)"></donation-status>

		<!-- extra field -->
		<extrafield [contact]="contact" [form]="widgetPaymentForm" *ngIf="step == 'payment' && contactMandatory == false"></extrafield>

		<!-- payment -->
		<payment [donation]="donation"  [amount]="donation.amount" [rythm]="donation.rythm" [contact]="contact" [form]="widgetPaymentForm" [(donationStatus)]="donationStatus" [size]=size [(step)]="step" [version]="version" (stepChange)="stepChange($event)"></payment>

		<!-- event Donator -->
		<donator [donation]="donation" [form]="widgetPaymentForm" *ngIf="(projectType === 'event' || showDonatorData) && !(version == 'page' && (size == 'medium' || size == 'large') || step === 'payment-select')"></donator>

		<!-- donation data for sending the data to an external form -->
		<hidden-formsubmit [id]="'value2'" [donation]="donation" [contact]="contact" [type]="version" [step]="step" [size]="size" [form]="widgetPaymentForm"></hidden-formsubmit>

		<!-- remarks on this donation -->
		<input-remarks *ngIf="step != 'payment-select'" [form]="widgetPaymentForm" [donation]="donation" [wrapperClass]="'remarks-wrapper row column'"></input-remarks>

		<!-- Button -->
		<div class="row columns" *ngIf="step == 'payment'">
			  <div id="expresscheckout"></div>
				<submit [text]="paymentSubmitTextkey | translate: getSubmitButtonPlaceholders()" [arrow]="false" [additionalClasses]="widgetPaymentForm.valid? '' : 'grey'" [secureText]="'payment.submit.hint' | translate"></submit>
		</div>
	</form>

	<!-- iframe, status -->
	<donation-status [status]="donationStatus" [donation]="donation" [message]="donationStatusMessage" (statusChange)="onStatusChange($event)" *ngIf="step == 'iframe' || step == 'contact-mandatory-finished'"></donation-status>
	<payment-iframe [donation]="donation" [buttonPlaceholders]="getSubmitButtonPlaceholders()" [projectType]="projectType" *ngIf="step == 'iframe'"></payment-iframe>

	<!-- step: thank you -->
	<thankyou-order [step]="step" [projectType]="projectType" [donation]="donation" [contact]="contact" [form]="contactForm" [size]="size" [version]="version" (stepChange)="stepChange($event, true)"></thankyou-order>

	<share *ngIf="projectType == 'event'" [projectType]="projectType" [step]="step"></share>

	<!-- back button for events -->
	<div class="row column event-back" *ngIf="projectType == 'event' && (step == 'thankyou' || step == 'end')">
		<button class="button hollow arrow-left" (click)="reloadWidget()" >{{'event.back.button' | translate }}</button>
	</div>

</div>

<footerdata [(step)]="step" [version]="version" (stepChange)="stepChange($event)" [projectType]="projectType" [size]="size"></footerdata>

<!-- donators -->
<project-donators [projectType]="projectType" [step]="step" [donation]="donation" *ngIf="(projectType == 'event' || showDonatorData) && step != 'banktransfer' && step != 'contact'"></project-donators>

<div class="row column simple-keyboard-wrapper">
	<div class="simple-keyboard" id="simple-keyboard"></div>
</div>

<tracking></tracking>
